module.exports = __webpack_public_path__ + "media/images/products/retailers-product-5-product-page-dec1871fb49e57c118a2e40262493fc2.jpg";